import { render } from "./BaseForm.vue?vue&type=template&id=105aa0b7"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__